import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-user-approval-status',
  templateUrl: './user-approval-status.component.html',
  styleUrls: ['./user-approval-status.component.scss']
})
export class UserApprovalStatusComponent implements OnInit {

  status: string = 'approved'

  constructor(private activatedRoute: ActivatedRoute) {
    this.status = this.activatedRoute.snapshot.params.status;
  }

  ngOnInit(): void {
  }

}
